/* *********************************************
+++++ HELPFUL ASSETS & DOCUMENTATION +++++
https://drive.google.com/drive/folders/138vKvlsn9NNw9FeYom5nOq7yFy3CoXa4?usp=sharing
********************************************* */



/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { render } from 'inferno';
import { Provider } from 'inferno-redux';
import configureStore from 'redux/store/store';
import { settings } from 'config/config';
import { initDevTools } from 'inferno-devtools';
import { log } from 'utils/logger';
import App from 'components/app_container';
import { checkDomAndAppenedStyles } from 'utils/append_code';

// progressive web app (offline caching)
import 'registerServiceWorker';

// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'index_styles';
import { createStyles } from 'utils/styles';
createStyles(styles); // create global styles (no need to assign to var and use on a JSX element below for this file)

// temp testing tools
require('inferno-devtools');

//append custom stylesheet
checkDomAndAppenedStyles();

// CURRENT EMBED VERSION

// Major.Minor.Build.Beta
// Major = Core application code has been completely rewritten
// Minor = Feature additions (stories, security enhancement, etc)
// Build = Incremental bundled updates (tracking changes, API adjustments, AB Testing,  etc)
// Beta = Not yet ready for release but may be tested in a production environment

const embedVersion = '4.6.0';
// previous version: '4.5.25.5'
// reason for change:
// New local urls
console.log('\x1b[43m%s\x1b[0m', `EMBED VERSION: ${embedVersion}`);
window.insticatorEmbedVersion = embedVersion;



/* /////////////// RENDER \\\\\\\\\\\\\\\ */
// MAIN ENTRY POINT
// utilizes "provider" for redux application state management
// "provider" helps child components have access to store (application state)
// this is done by passing the configureStore function as a value to the store prop (inherent redux functionality)
initDevTools();
render(
  <Provider store={configureStore(settings)}>
    <App />
  </Provider>,
  document.getElementById('app')
);